// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"MC","blender_bottle_img":"NC","blender_bottle_info":"OC","blender_bottle_title":"PC","blender_bottle_bold":"QC","blender_bottle_usual":"RC","blender_bottle_item_mob":"SC","addbutton":"TC","blender_bottle_title_mob":"UC","blender_bottle_bold_mob":"VC","blender_bottle_usual_mob":"WC","bolder":"XC","bottom_margin_4":"YC","bottom_margin_16":"ZC"};
    if(module.hot) {
      // 1714654893244
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  